import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ArtistHeader = ({ artist, onEdit, onPreview }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'text-success bg-success/10';
      case 'pending': return 'text-warning bg-warning/10';
      case 'inactive': return 'text-error bg-error/10';
      default: return 'text-text-secondary bg-muted';
    }
  };

  const getArtistTypeIcon = (type) => {
    switch (type) {
      case 'Music': return 'Music';
      case 'Visual': return 'Palette';
      case 'Model': return 'Camera';
      case 'Actor': return 'Video';
      default: return 'User';
    }
  };

  return (
    <div className="bg-surface border border-border rounded-lg p-6 elevation-1">
      <div className="flex items-start justify-between">
        <div className="flex items-start space-x-4">
          <div className="relative">
            <div className="w-16 h-16 rounded-full overflow-hidden bg-muted">
              <Image
                src={artist?.profileImage}
                alt={`${artist?.name} profile`}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-accent rounded-full flex items-center justify-center">
              <Icon name={getArtistTypeIcon(artist?.type)} size={12} color="white" />
            </div>
          </div>
          
          <div className="flex-1">
            <div className="flex items-center space-x-3 mb-2">
              <h1 className="text-2xl font-semibold text-text-primary">{artist?.name}</h1>
              <span className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(artist?.status)}`}>
                {artist?.status}
              </span>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
              <div className="space-y-2">
                <div className="flex items-center space-x-2">
                  <Icon name="User" size={16} className="text-text-secondary" />
                  <span className="text-text-secondary">Artist Type:</span>
                  <span className="text-text-primary font-medium">{artist?.type}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Mail" size={16} className="text-text-secondary" />
                  <span className="text-text-secondary">Email:</span>
                  <span className="text-text-primary">{artist?.email}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Phone" size={16} className="text-text-secondary" />
                  <span className="text-text-secondary">Phone:</span>
                  <span className="text-text-primary">{artist?.phone}</span>
                </div>
              </div>
              
              <div className="space-y-2">
                <div className="flex items-center space-x-2">
                  <Icon name="Calendar" size={16} className="text-text-secondary" />
                  <span className="text-text-secondary">Joined:</span>
                  <span className="text-text-primary">{artist?.joinedDate}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Clock" size={16} className="text-text-secondary" />
                  <span className="text-text-secondary">Last Modified:</span>
                  <span className="text-text-primary">{artist?.lastModified}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Globe" size={16} className="text-text-secondary" />
                  <span className="text-text-secondary">Website:</span>
                  <a href={artist?.website} className="text-accent hover:underline" target="_blank" rel="noopener noreferrer">
                    {artist?.website}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            iconName="Smartphone"
            iconPosition="left"
            onClick={onPreview}
          >
            Preview App
          </Button>
          <Button
            variant="default"
            size="sm"
            iconName="Edit"
            iconPosition="left"
            onClick={onEdit}
          >
            Edit Profile
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ArtistHeader;